import { useState, useEffect } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

export interface UnlayerUser {
  id: string;
  signature: string;
}

// Récupère la signature HMAC (générée côté backend à partir de la clé secrète Unlayer) qui
// authentifie l'éditeur Unlayer auprès du compte/projet — la clé elle-même ne quitte jamais le serveur.
export const useUnlayerUserSignature = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
  const [user, setUser] = useState<UnlayerUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isReady) return;
    let cancelled = false;

    (async () => {
      try {
        const result = await authFetch('/communication/unlayer/user');
        if (!cancelled && result?.id && result?.signature) {
          setUser({ id: result.id, signature: result.signature });
        }
      } catch (err) {
        if (!cancelled) setError(err instanceof Error ? err.message : "Erreur lors de l'authentification Unlayer");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [authFetch, isReady]);

  return { user, loading: isReady ? loading : true, error };
};
